<div class="account-dialog" style="width: 40rem">
    <div class="title" mat-dialog-title>Add Currency & Timezone</div>
    <div class="dialog-body">
        <div class="body-content">
            <div class="form-text">You will need to specify the currency and timezone for this Criteo connection</div>
    
            <form [formGroup]="connectionForm">
    
                <mat-form-field class="name-select" appearance="outline" class="form-field">
                    <mat-label>Currency</mat-label>
                    <mat-select required="true" formControlName="currency">
                        <mat-option *ngFor="let currency of currencies" [value]="currency.name">
                           {{currency.name}} - {{currency.symbol}} 
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="name-select" appearance="outline" class="form-field">
                    <mat-label>Timezone</mat-label>
                    <mat-select required="true" formControlName="timezone">
                        <mat-option *ngFor="let timezone of timezones" [value]="timezone">
                            {{timezone}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
    
                <!-- <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Currency</mat-label>
                    <mat-select multiple [formControl]="gadsCustomerIds">
                        <mat-option *ngFor="let customer of data.userProfilesOrAgencies" [value]="customer.id + ''">
                            {{customer.id + ' - ' + customer.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field> -->
    
                <!-- <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Timezone</mat-label>
                    <input matInput placeholder="Enter Timezone" formControlName="timezone">
                </mat-form-field> -->
            </form>
        </div>
    </div>
    <div class="dialog-footer">
        <div>
            <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="save()">
                Save connection
            </button>
        </div>
    </div>
</div>